export interface ApproveFacilityOnboardingDto {
  facilityId?: string | null;
  userId?: string | null;
  approvalNotes?: string | null;
}

export interface ApproveFacilityOnboardingResponseDto {
  facilityId: string;
  facilityName: string;
  facilityAdminId: string;
  userId: string;
  userEmail: string;
  userFullName: string;
  approvedAt: string; // DateTime as ISO string
  message: string;
}
